/*
 * Adapted from https://github.internal.digitalocean.com/digitalocean/aurora/blob/309185217900d936ffbdf1a3f6ebdbd4e60ab1f4/app/utils/regex-for-generated-name.js#L1
 *
 * Example:
 * regexForGeneratedName('load-balancer', 'fra1')
 * returns a regex that matches
 *   fra1-load-balancer-05
 *   fra1-load-balancer-48
 * but does NOT match
 *   foo-fra1-load-balancer-05
 *   fra1-load-balancer-05-bar
 */
export function getGeneratedNameRegex(hyphenatedResourceType: string, regionSlug: string): RegExp {
  // Converts `some-resource-type` to `some\-resource\-type`
  // eslint-disable-next-line no-useless-escape
  hyphenatedResourceType = hyphenatedResourceType.replace(/-/g, "\\-");

  return new RegExp(
    // The escaped hyphens and backslashes below are necessary.
    // See also: https://stackoverflow.com/a/17863171/349353
    // eslint-disable-next-line no-useless-escape
    `^${regionSlug}\-${hyphenatedResourceType}\-\\d\\d$`
  );
}
